import { TableHead, TableRow, TableCell, TableSortLabel, Box } from "@mui/material";
import { IHeadProps, ITemplateData } from "../../../entities/table";
import { templatesHeaders } from "../../../lib/referentiel";
import { visuallyHidden } from '@mui/utils';

interface IProps extends IHeadProps<ITemplateData> {}
  

export const Head: React.FC<IProps> = (props: IProps) => {
    const { order, orderBy, onRequestSort } = props;

    const createSortHandler = (property: keyof ITemplateData) => (event: React.MouseEvent<unknown>) => {
        onRequestSort(event, property);
      };
  
    return (
      <TableHead>
        <TableRow>
          {templatesHeaders.map((headCell) => (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? 'right' : 'left'}
              padding={headCell.disablePadding ? 'none' : 'normal'}
              sortDirection={orderBy === headCell.id ? order : false}
              sx={{fontWeight: 'bold'}}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  }
  